import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import events from 'packages/alcumus-local-events'

import uniq from 'lodash/uniq'

import { isAdmin } from 'common/global-store/api'
import ChipMultiSelectField from 'common/ChipMultiSelectField'
import { getRegisteredDemands } from './request-selectors'

const getRevisedDemandName = (d) => {
    if (d === 'upload-client-documents') return 'client-documents'
    if (d === 'upload-contractor-documents') return 'contractor-documents'
    return d
}

export function Demands({ onChange, value, readonly, label, ...props }) {
    const [demands, setDemands] = useState([])

    useEffect(() => {
        let availableDemands = events.modify('get-demands', [])
        let registeredDemands = uniq(availableDemands)
        getRegisteredDemands(registeredDemands, true).then((allowedDemands) => {
            if (!isAdmin()) {
                allowedDemands = allowedDemands.filter((d) => d !== 'manage-clients')
            }
            setDemands(allowedDemands)
        })
    }, [])

    return (
        <ChipMultiSelectField
            disabled={readonly}
            onChange={onChange}
            value={value}
            variant="outlined"
            options={demands}
            getOptionLabel={getRevisedDemandName}
            getChipProps={() => ({ color: 'primary' })}
            fullWidth
            label={label}
            {...props}
        />
    )
}

Demands.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.any,
    readonly: PropTypes.bool,
    value: PropTypes.any,
}
